<template>
  <modal
    :adaptive="false"
    :click-to-close="false"
    :shift-y="0.5"
    name="alert"
    height="70%"
    style="z-index: 1 !important;"
    @before-open="ready"
  >
    <div class="container mx-auto px-5 sm:px-20">
      <div class="px-5 py-5 sm:py-10 rounded-lg border-2 border-black bg">
        <!-- eslint-disable -->
        <h3 class="text-xl sm:text-3xl font-bold text-center text-white" v-html="title"></h3>
        <!--end::title-->
        <!-- eslint-disable -->
        <div
          class="p-4 sm:p-10 bg-white rounded-lg mt-4 sm:mt-10 text-lg sm:text-2xl tracking-wider text-center"
          v-html="content"
        ></div>
        <!--end::content-->

        <div v-if="buttons" class="flex mt-10">
          <div v-for="(button, index) of buttons" :key="index" class="flex-1">
            <JGButtonPrimary
              v-if="button.title && button.handler"
              :class="button.class"
              :color="button.color"
              class="w-full text-base sm:text-xl"
              @click="button.handler"
            >
              {{ button.title }}
            </JGButtonPrimary>
          </div>
        </div>
        <!--end::footer-->
      </div>
    </div>
  </modal>
</template>

<script>
import * as _ from 'lodash'
import JGButtonPrimary from '@src/games/jongrogu/components/jg-button-primary.vue'

export default {
  name: 'JGAlert',
  components: { JGButtonPrimary },
  data() {
    return {
      title: null,
      content: null,
      buttons: null,
    }
  },
  methods: {
    ready(event) {
      this.title = _.get(event, 'params.title')
      this.content = _.get(event, 'params.content')
      this.buttons = _.get(event, 'params.buttons')
    },
  },
}
</script>

<style scoped>
.bg {
  background-color: #464444;
}
</style>
